module.exports = __webpack_public_path__ + "static/media/0520-r-l-en.7ae0dc5e.png";